import React, { useCallback, useState } from 'react';
import { ComboItem } from '../utils/comboItems';
import { useEscapeKey } from '../hooks/useEscapeKey';
import ImageLightbox from './ImageLightbox';

interface Props {
    items: ComboItem[],
    onClose: () => void
}

function ComboModal({ items, onClose }: Props) {
    const [expandedItem, setExpandedItem] = useState<ComboItem | null>(null);
    const closeLightbox = useCallback(() => setExpandedItem(null), []);

    // While an image is expanded, Escape closes only the image.
    useEscapeKey(onClose, !expandedItem);

    return (
        <>
        <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
            <div className="combo-modal-content" onClick={e => e.stopPropagation()}>
                <div className="combo-modal-header">
                    <h3>Combo Items</h3>
                    <button className="modal-close" onClick={onClose} aria-label="Close dialog">✕</button>
                </div>

                <div className="combo-modal-body">
                    {items.length > 0 ? (
                        <div className="combo-modal-grid">
                            {items.map((item, idx) => (
                                <div key={`${item.url}-${idx}`} className="combo-modal-item">
                                    <button
                                        className="combo-modal-image expandable-image"
                                        onClick={() => setExpandedItem(item)}
                                        aria-label={`Expand image of ${item.name}`}
                                    >
                                        <img src={item.url} alt={item.name} loading="lazy" />
                                        {item.quantity > 1 && <span className="quantity-badge">x{item.quantity}</span>}
                                    </button>
                                    <h5 className="combo-modal-item-title">{item.name}</h5>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="combo-modal-empty">No combo items found.</p>
                    )}
                </div>
            </div>
        </div>
        {expandedItem && <ImageLightbox src={expandedItem.url} alt={expandedItem.name} onClose={closeLightbox} />}
        </>
    );
}

export default ComboModal;
